<template>
  <div id="compras-pendentes-sem-restricoes" class="w3-container w3-margin-top" style="padding: 0;">
    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando" class="w3-margin-bottom">
      <input 
        class="w3-input w3-border w3-padding margin-bottom-filtro" 
        type="text" 
        placeholder="Pesquise por nome ou código" 
        v-model="filtro"
        v-on:keyup="filtrarPedidos()">
    </div>

    <div 
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="!processando && ((!compras_filtradas) || (compras_filtradas.length == 0))" v-cloak>
      
      <div class="w3-container w3-white">
        <p>Não há pedidos de compra a serem exibidos.</p>
      </div>
    </div>
    
    <div 
      class="wrapper-componente"
      v-if="!processando && (compras_filtradas) && (compras_filtradas.length > 0)">

      <div 
        class="card-item w3-container"
        v-for="(compra, compra_index) in novasComprasFiltradas" 
        :key="compra_index"
        @click="mostrarDetalhesCompra(compra, !compra.mostrar_detalhes)">
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <strong>Código e valor da compra</strong>
              <i slot="referencia" class="fas fa-shopping-basket w3-text-theme"></i>&nbsp;
            </legenda>
            <strong class="w3-text-theme">{{compra.compra_id}}</strong>
            <strong class="w3-text-green w3-right">R$ {{compra.valor_pedido}}</strong>
          </strong>
        </div>
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <strong>Fornecedor</strong>
              <i slot="referencia" class="far fa-handshake w3-text-theme"></i>&nbsp;
            </legenda>
            <strong>{{compra.nome_fornecedor}}</strong>
          </strong>
        </div>
        
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <span>Data cadastro</span>
              <i slot="referencia" class="far fa-calendar-alt w3-text-theme"></i>&nbsp;
            </legenda>
            <label>{{compra.data_cadastro}}</label>
          </strong>
        </div>
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <span>Empresa</span>
              <i slot="referencia" class="fas fa-building  w3-text-theme"></i>&nbsp;
            </legenda>
            <label>{{compra.nome_empresa}}</label>
          </strong>
        </div>

        <transition name="fade" mode="out-in">
          <div class="w3-col s12" v-if="compra.mostrar_detalhes">
              <modal-compras-pendentes 
                :gerente="gerente" 
                :autorizacao_deletar="autorizacao_deletar"
                :compra_id="compra.compra_id"
                v-on:reprocessarCompras="buscarComprasPendentesSemNrFornecedor()">
              </modal-compras-pendentes>
          </div>
        </transition>
      </div>

      <paginacao
        @pagina="mudarPagina"
        :pagina-atual="pagina_atual"
        :itens-por-pagina="itens_por_pagina"
        :total-resultados="total_resultados" 
        :total-de-paginas="total_de_paginas"/>
    </div>
  </div>
</template>

<script>
  import ModalComprasPendentes from '@/components/Dashboard/ModalComprasPendentes.vue'
  import Paginacao from '@/components/Paginacao'
  import toastr from 'toastr'
  import legenda from '@/components/Legendas'
  import RCompraBuscarComprasSemNrFornecedorDashboard from '@/components/Rest/RCompra/RCompraBuscarComprasSemNrFornecedorDashboard'
  
  export default {
    name: 'ComprasPendentesSemNrFornecedor', 

    components: {
      Paginacao,
      ModalComprasPendentes,
      legenda
    },

    props: ['autorizacao_deletar', 'gerente'],

    data() {
      return {
        filtro: '',
        processando: false,
        compras_abertas: [],
        compras_filtradas: [],

        pagina_atual: 0,
        itens_por_pagina: 10,
        total_resultados: 0,
        total_de_paginas: 0
      }
    },

    methods: {
      mostrarDetalhesCompra(index, condicional) {
        this.$set(index, 'mostrar_detalhes', condicional)
      },

      mudarPagina(numeroDaPagina) {
        this.pagina_atual = numeroDaPagina;
      },

      filtrarPedidos() {
        this.compras_filtradas = [];
        this.mudarPagina(0);

        if (this.filtro == '') {
          this.compras_filtradas = this.compras_abertas;
          return;
        }

        for (let i = 0; i < this.compras_abertas.length; i++) {
          if (this.compras_abertas[i].nome_fornecedor.toUpperCase().indexOf(this.filtro.toUpperCase()) > -1) {
            this.compras_filtradas.push(this.compras_abertas[i]);
          }
        }
      },

      async buscarComprasPendentesSemNrFornecedor() {
        this.processando = true;
        this.compras_filtradas.length = 0;

        try {
          let retorno = await RCompraBuscarComprasSemNrFornecedorDashboard.buscarComprasSemNrFornecedorDashboard(
            this.axios
          );
          console.log(retorno)
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.compras_abertas = JSON.parse(JSON.stringify(retorno.dados.compras_fornecedor))
          this.compras_filtradas = JSON.parse(JSON.stringify(retorno.dados.compras_fornecedor))
          this.processando = false;
        }
        catch (error) {
          this.processando = false;
          toastr.error(error.message);
        }
      }
    },

    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    created() {
      this.buscarComprasPendentesSemNrFornecedor();
    },

    computed: {
      novasComprasFiltradas() {       
        this.total_resultados = this.compras_filtradas.length;
        this.total_de_paginas =  Math.ceil(this.total_resultados / this.itens_por_pagina);

        if(this.pagina_atual >= this.total_de_paginas) { 
          this.pagina_atual = this.total_de_paginas;
        }

        let index = this.pagina_atual * this.itens_por_pagina;
        return this.compras_filtradas.slice(index, index + this.itens_por_pagina);
      }
    }
  }
</script>

<style scoped>
  
  .card-item {
    background: rgb(235, 235, 235);
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
  
  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .tr-items-ativo:hover {
    background: #9c1d1cb8;
    color: white;
  }

  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
  }

  .mapa-financeiro-card {
    padding: 0 !important
  }

  th {
    white-space: nowrap;
  }

  .wrapper-componente {
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ComprasPendentesSemNrFornecedor.vue